import React, {FunctionComponent, useCallback} from "react";
import {ReduxActions, useAppDispatch, useAppSelector} from "../../redux";
import {Button, Card, Dialog, DialogContent, Typography} from "@mui/material";
import {LazyLoadImage} from "../../../@bizkeytech";
import EnvService from "../../../core/services/env";
import {AddBoxOutlined, IosShareRounded} from "@mui/icons-material";

const ViewInstallationGuideDialog: FunctionComponent = () => {
    const dispatch = useAppDispatch();
    const state = useAppSelector(state => state.dialogs?.viewInstallationGuide);

    const {hideCloseButton, disableBackdropClick, ...dialogProps} = state;

    /**
     * Closes the dialog by dispatching its relevant action to the redux store.
     */
    const closeDialog = useCallback((successful = false) => {
        if (state?.onClose) {
            state.onClose(successful ? "successful" : "leave");
        }
        dispatch(ReduxActions.dialogs.viewInstallationGuide({open: false}));
    }, [state, dispatch])

    /**
     * Closes the dialog if the values from the state do not prevent the closing of the dialog.
     */
    const onDialogClosed = useCallback((event: Object, reason: 'backdropClick' | 'escapeKeyDown' | 'closeClick') => {
        switch (reason) {
            case "backdropClick":
                if (!state.disableBackdropClick)
                    closeDialog();
                break;
            case "closeClick":
                if (!state.hideCloseButton)
                    closeDialog();
                break;
            case "escapeKeyDown":
                if (!state.disableEscapeKeyDown)
                    closeDialog();
                break;
            default:
                break;
        }
    }, [closeDialog, state.disableBackdropClick, state.disableEscapeKeyDown, state.hideCloseButton])

    return (
        <>
            <Dialog
                {...dialogProps}
                onClose={onDialogClosed}
            >
                <DialogContent sx={{display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center'}}>
                    <LazyLoadImage
                        src={(window.location.origin.concat('/assets/images/logo.png'))}
                        className={'panel-image'}
                        wrapperClassName={'panel-image-wrapper'}
                        style={{width: 65, height: 65,}}
                        placeholderSrc={undefined}
                    />
                    <Typography variant={'h5'} fontWeight={600} color={'primary'}>
                        {EnvService.websiteName}
                    </Typography>
                    <Typography variant={'body1'}>
                        Installation Guide on how to add this application to your home screen.
                    </Typography>
                    <Card sx={{display: 'flex', flexDirection: 'column', gap: 2, padding: 3}} variant={'outlined'}>
                        <Typography variant={'body2'}>
                            1. Tap the <strong style={{marginInline: 4}}>Share</strong>
                            button <IosShareRounded sx={{height: 15}}/> near the address bar of your browser.
                        </Typography>
                        <Typography variant={'body2'}>
                            2. In the Share menu, tap on <strong style={{marginInline: 4}}>
                            "Add to Home Screen <AddBoxOutlined sx={{height: 15}}/>"</strong>.
                        </Typography>
                        <Typography variant={'body2'}>
                            2. Click on "Add" to add the application to your home screen.
                        </Typography>
                        <Button
                            type={'button'}
                            color={'primary'}
                            variant={'contained'}
                            size={'medium'}
                            onClick={() => closeDialog()}
                        >
                            Understood
                        </Button>
                    </Card>
                </DialogContent>

            </Dialog>
        </>
    )
}

export default ViewInstallationGuideDialog;
